@if (value()) {
  <app-advertising-form
    [(value)]="value"
    [edit]="true"
    [create]="false"
    [delete]="false"
    [details]="false"
    [access]="access()"
  ></app-advertising-form>
}
